import type { Selection } from "./selection";

/**
 * The custody transfer meter's settled per-gas-day energy register is the source
 * of record for the RFS4800 utility-energy calculation and for the LCFS credits.
 * The meter's raw running total and the hand-entered statement table are both
 * reconciliation-only and no longer offered in the picker.
 */
export const CUSTODY_FILING_ENERGY_ROLE = "hub_custody_energy";

/**
 * What a Data surface charts before the user picks anything: the hub outlet
 * meter, volume and energy.
 *
 * Deliberately just these two, and deliberately one meter. The surfaces used to
 * disagree — the batch tab opened on four hub series plus two dairies seeded
 * from the roster, the Explorer on two unrelated energy series — so the first
 * thing anyone saw was a busy chart nobody had asked for, and different on each
 * surface.
 *
 * Volume and energy do sit on separate y-axes (SeriesChart splits by
 * `unitGroup`). That is the point rather than a cost: they are the two figures
 * the same meter reports, so seeing them together is the reading a reviewer
 * actually wants, and the chart is built to carry exactly two axes.
 */
export const DEFAULT_SELECTION: Selection[] = [
  { role: "hub_outlet_volume", facility: null },
  { role: "hub_outlet_energy", facility: null },
];

/**
 * The two series the batch tab's calc-reconciliation strip compares against the
 * engine's period figures.
 *
 * Fetched independently of what the user has charted. They used to be read out
 * of the selection, so the strip only worked while its two roles happened to be
 * selected — and it silently read "pending" the moment anyone removed one. It is
 * a fixed comparison against two fixed calc figures, so it owns its own reads.
 */
export const RECONCILIATION_SERIES: Selection[] = [
  { role: "hub_inlet_energy", facility: null },
  { role: CUSTODY_FILING_ENERGY_ROLE, facility: null },
];
